import conf from './../../../conf.js';
import validate from '../../../services/reduxValidate.js';

export default function(data) {
  const constraints = {
    // Identity
    'user.firstname': { presence: { allowEmpty: false } },
    'user.lastname': { presence: { allowEmpty: false } },
    // Status
    'freelance.work_permit': { presence: { allowEmpty: false } },
    'freelance.situation': { presence: { allowEmpty: false } },
    // Availability
    'freelance.date_available': { isoDate: true, presence: { allowEmpty: false } },
    // Mission duration and format
    'freelance.part_time': { presence: { allowEmpty: false } },
    // Location and mobility
    'freelance.target_cities': { presence: { allowEmpty: false } },
    'freelance.relocation_long_fulltime': { inclusion: { within: [true, false] } },
  };

  const errors = {
    freelance: {},
    user: {},
  };
  // References
  if (data.freelance.references) {
    const referencesArrayErrors = [];
    data.freelance.references.forEach((reference, index) => {
      referencesArrayErrors[index] = validateContact(reference);
    });
    errors.freelance.references = referencesArrayErrors;
  }

  // Contacts
  if (data.user.prospects) {
    const contactsArrayErrors = [];
    data.user.prospects.forEach((prospect, index) => {
      contactsArrayErrors[index] = validateContact(prospect);
    });
    errors.user.prospects = contactsArrayErrors;
  }

  // City
  let city = data.user.city;
  if (Array.isArray(city)) {
    city = city[0];
  }

  if (!city || city.label === "" || !city.id) {
    errors.user.city = 'La ville est invalide';
  }

  // Prices
  const price = data.freelance.price;
  const yearlyBrut = data.freelance.yearly_brut;

  if (!price && !yearlyBrut) {
    errors.freelance.price = 'Veuillez renseigner un TJM';
  } else {
    if (price) {
      const validationPrice = validatePrice(price);
      if (validationPrice) {
        errors.freelance.price = validationPrice.price;
      }
    }
    if (yearlyBrut) {
      const validationYearlyBrut = validateYearlyBrut(yearlyBrut);
      if (validationYearlyBrut) {
        errors.freelance.yearly_brut = validationYearlyBrut.yearlyBrut;
      }
    }
  }

  const validation = validate(data, constraints);

  return {
    freelance: {...errors.freelance, ...(validation ? validation.freelance : {}) },
    user: {...errors.user, ...(validation ? validation.user : {}) },
  };
}

const validatePrice = (price) => {
  return validate({price}, {
    price: {
      numericality: {
        onlyInteger: true,
        strict: true,
        greaterThan: 0,
        lessThan: 50000,
        notGreaterThan: 'Votre TJM mission minimum doit être supérieur a 0€',
        notLessThan: 'Votre TJM mission minimum doit être inférieur à 50 000€',
      }
    }
  });
};

const validateYearlyBrut = (yearlyBrut) => {
  return validate({yearlyBrut}, {
    yearlyBrut: {
      numericality: {
        onlyInteger: true,
        strict: true,
        greaterThan: 0,
        lessThan: 500000,
        notGreaterThan: 'Votre montant annuel brut doit être supérieur a 0€',
        notLessThan: 'Votre montant annuel brut doit être inférieur à 500 000€'
      }
    }
  });
};

const validateContact = (contact) => {
  const required = 'Ce champ est requis';
  const contactErrors = {};

  if (!contact || !contact.civility) {
    contactErrors.civility = required;
  } else if (!Object.values(conf.civilities).includes(contact.civility)) {
    contactErrors.civility = 'La civilité est invalide';
  }

  if (!contact || !contact.firstname) {
    contactErrors.firstname = required;
  }
  if (!contact || !contact.lastname) {
    contactErrors.lastname = required;
  }
  if(!isValidEmail(contact)) {
    contactErrors.email = 'L\'adresse e-mail est invalide';
  }
  if(!isValidTel(contact)) {
    contactErrors.tel = 'Le numéro de téléphone est invalide (format souhaité : +33612345678)';
  }

  return contactErrors;
};

const isValidEmail = (contact) => {
  const constraints = {
    email: {
      email: {
        message: 'L\'adresse e-mail est invalide'
      },
      presence: { allowEmpty: false },
    },
  };

  return !validate(contact, constraints);
};

const isValidTel = (contact) => {
  const constraints = {
    tel: {
      format: {
        pattern: /(^\+?([0-9.\-\s]+)$)?/g,
        message: "Le numéro de téléphone est invalide (format souhaité : +33612345678)"
      }
    },
  };

  return !validate(contact, constraints);
};
